import { Component, inject, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { selectAdminTicketTypes } from '../../../../../../data-services/stores/selectors/admin.selectors';
import { InputNumberModule } from "primeng/inputnumber";
import { SelectChangeEvent, SelectModule } from "primeng/select";
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EventTicketComplete } from '../../../../../../data-services/models/event-tickets/event-ticket-complete.model';
import { adminActions } from '../../../../../../data-services/stores/actions/admin.actions';
import { EventComplete } from '../../../../../../data-services/models/events/event-complete.model';

@Component({
  selector: 'app-new-ticket',
  imports: [InputNumberModule, SelectModule, CommonModule, FormsModule,ReactiveFormsModule,FontAwesomeModule],
  templateUrl: '../ui/new.component.html',
  styleUrl: '../ui/new.component.css',
})
export class NewComponent implements OnInit {
  private readonly _store = inject(Store);
  @Input({required:true}) lrpEvent!: EventComplete;
  @Input() showTicketList:boolean = false;
  
  ticketTypes$ = this._store.select(selectAdminTicketTypes)
  cateringTickets:string[] = ['Meal','Meal (Under 16)']

  ticketForm: FormGroup = new FormGroup({
    ticketType: new FormControl<string>('',[Validators.required, Validators.minLength(3)]),
    ticketCost: new FormControl<number>(0,[Validators.required, Validators.min(0)]),
    description: new FormControl<string>('',[Validators.required, Validators.minLength(3)]),
    availableTo: new FormControl<Date | undefined>(undefined, [Validators.required]),
    availableFrom: new FormControl<Date | undefined>(undefined, [Validators.required]),
    caterer: new FormControl<string>('',[ ])
  })

  ngOnInit(): void {
    const ticketTypeControl = this.ticketForm.get('ticketType') as FormControl;
    const catererControl = this.ticketForm.get('caterer') as FormControl;

    const updateCatererValidator = (value: any) => {
      const v = typeof value === 'string' ? value : '';
      if (this.cateringTickets.includes(v)) {
        catererControl.setValidators([Validators.required, Validators.minLength(1)]);
      } else {
        catererControl.clearValidators();
      }
      catererControl.updateValueAndValidity({ onlySelf: true });
    }

    // Initial check
    updateCatererValidator(ticketTypeControl.value);

    // Update when ticketType changes
    ticketTypeControl.valueChanges.subscribe(updateCatererValidator);
  }

  onSelectChange(event:SelectChangeEvent){
    this.ticketForm.controls['description'].setValue(event.value + ' Ticket')
  }

  addTicket(){
    const ticketType = this.ticketForm.controls['ticketType'].value
    const eventTicket:EventTicketComplete = {
      caterer: this.ticketForm.controls['caterer'].value || undefined,
      restrictions: ticketType === 'Staff' ? 'By Invite Only' : '',
      ticketID: 0,
      eventID: this.lrpEvent.eventID!,
      ticketType,
      name: ticketType,
      available: false,
      description: this.ticketForm.controls['description'].value,
      availableFrom: this.ticketForm.controls['availableFrom'].value,
      availableTo: this.ticketForm.controls['availableTo'].value,
      cost: this.ticketForm.controls['ticketCost'].value
    }

    this._store.dispatch(adminActions.addEventTicket({ eventTicket }))
  }
}
